import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcCircleAlert = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85787 16.5 1.5 13.1421 1.5 9C1.5 4.85787 4.85787 1.5 9 1.5C13.1421 1.5 16.5 4.85787 16.5 9ZM9.02879 4.38461C9.50673 4.38461 9.89417 4.77206 9.89417 5.25V9.76264C9.89417 10.2406 9.50673 10.628 9.02879 10.628C8.55085 10.628 8.16341 10.2406 8.16341 9.76264V5.25C8.16341 4.77206 8.55085 4.38461 9.02879 4.38461ZM9.02884 11.8847C9.50678 11.8847 9.89423 12.2721 9.89423 12.7501V12.7548C9.89423 13.2327 9.50678 13.6202 9.02884 13.6202C8.55091 13.6202 8.16346 13.2327 8.16346 12.7548V12.7501C8.16346 12.2721 8.55091 11.8847 9.02884 11.8847Z",
		fill: "#03A65B"
	})]
});
const ForwardRef = forwardRef(SvgIcCircleAlert);
export default ForwardRef;
